import { deviceDetector } from './utils/deviceDetector';

/**
 * Sets the device type as a class on the body and the cast player wrapper element (`.player#castPlayer`)
 */
export const setDeviceVersionOnRootElements = () => {
  // Get device version
  const deviceVersion = deviceDetector();

  // Set device version on body
  const { body } = document;
  body.classList.add(deviceVersion);

  // Set device version on wrapper element in the shadowRoot (`.player#castPlayer`)
  document
    .getElementById('castPlayer')
    ?.shadowRoot?.querySelector('.player#castPlayer')
    ?.classList.add(deviceVersion);
};
